module.exports = __webpack_public_path__ + "img/yowhatsapp-cover.25b79ff6.webp";